import {
  BOARD_INLAY_OFFSET,
  BOARD_INLAY_SIZE,
  BOARD_OUTER_OFFSET,
  BOARD_OUTER_SIZE,
  DEFAULT_BOARD_SIZE,
  SQUARE_SIZE,
} from '../utils/constants.js';
import type { Square } from '../game/types.js';

/** 0 = white-at-bottom, 180 = black-at-bottom (board flipped). */
export type ViewerRotation = 0 | 180;

export interface Rect {
  readonly x: number;
  readonly y: number;
  readonly w: number;
  readonly h: number;
}

export function squareToCanvasCenter(
  square: Square,
  rotation: ViewerRotation = 0,
): { x: number; y: number } {
  const { row, col } = viewerCoordinates(square, rotation);
  return {
    x: BOARD_INLAY_OFFSET + col * SQUARE_SIZE + SQUARE_SIZE / 2,
    y: BOARD_INLAY_OFFSET + row * SQUARE_SIZE + SQUARE_SIZE / 2,
  };
}

export function squareToCanvasRect(
  square: Square,
  rotation: ViewerRotation = 0,
): Rect {
  const { row, col } = viewerCoordinates(square, rotation);
  return {
    x: BOARD_INLAY_OFFSET + col * SQUARE_SIZE,
    y: BOARD_INLAY_OFFSET + row * SQUARE_SIZE,
    w: SQUARE_SIZE,
    h: SQUARE_SIZE,
  };
}

export function canvasToSquare(
  x: number,
  y: number,
  rotation: ViewerRotation = 0,
): Square | null {
  const dx = x - BOARD_INLAY_OFFSET;
  const dy = y - BOARD_INLAY_OFFSET;
  if (dx < 0 || dy < 0 || dx >= BOARD_INLAY_SIZE || dy >= BOARD_INLAY_SIZE) return null;
  const canvasCol = Math.floor(dx / SQUARE_SIZE);
  const canvasRow = Math.floor(dy / SQUARE_SIZE);
  if (rotation === 0) return { row: canvasRow, col: canvasCol };
  return {
    row: DEFAULT_BOARD_SIZE - 1 - canvasRow,
    col: DEFAULT_BOARD_SIZE - 1 - canvasCol,
  };
}

export function getBoardOuterRect(): Rect {
  return {
    x: BOARD_OUTER_OFFSET,
    y: BOARD_OUTER_OFFSET,
    w: BOARD_OUTER_SIZE,
    h: BOARD_OUTER_SIZE,
  };
}

export function getInlayRect(): Rect {
  return {
    x: BOARD_INLAY_OFFSET,
    y: BOARD_INLAY_OFFSET,
    w: BOARD_INLAY_SIZE,
    h: BOARD_INLAY_SIZE,
  };
}

function viewerCoordinates(
  square: Square,
  rotation: ViewerRotation,
): { row: number; col: number } {
  if (rotation === 0) return { row: square.row, col: square.col };
  return {
    row: DEFAULT_BOARD_SIZE - 1 - square.row,
    col: DEFAULT_BOARD_SIZE - 1 - square.col,
  };
}
